export default __webpack_public_path__ + "static/media/undraw_text_field_htlv.fa3edfdd.svg";